module.exports = __webpack_public_path__ + "assets/11798e9582349fa2b697c8bb2ca7f18d.mp4";